module.exports = __webpack_public_path__ + "img/photo.fb06ed14.jpg";